export const listOfColumnNames = [
    {
        colName: 'Region',
        title: 'region'
    },
    {
        colName: 'Company Name',
        title: 'counterpartyName'
    },
    {
        colName: 'Report Type',
        title: 'productName'
    },
    {
        colName: 'Delivery Date',
        title: 'deliveryDate'
    },
    {
        colName: 'Price',
        title: 'productPrice'
    },
];

export const fetchData = {
    fromDate: null,
    toDate: null,
    reportTypes: [],
    region: [],
    selectedCountry: [],
    selectedState: []

}

export const DEFAULT_REQUEST_BODY = {
    pageNumber: 0,
    pageSize: 10,
    sortfield: 'dueOrCompletedDate',
    sortDirection: 'desc',
    fetchData: {
        fromDate: null,
        toDate: null,
        reportTypes: [],
        region: [],
        selectedCountry: [],
        selectedState: []

    }
}

export let chartInfo = {}

export const sortColumn = 'Delivery Date';

export const ascSort = 'asc';

export const descSort = 'desc';